import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';

import { ErrorBoundary } from '@sentry/react';

import ErrorMessage from 'components/ErrorMessage';

import PosaleFooter from './PosaleFooter';

export default function PosalePageContainer({
  children,
  footerLeftContent,
  footerRightContent,
}) {
  return (
    <>
      <Stack
        alignItems='center'
        sx={(theme) => ({
          marginTop: '123px',
          padding: `${theme.spacing(2)} ${theme.spacing(3)}`,
          '@media print': {
            marginTop: theme.spacing(2),
          },
        })}
        flexGrow={1}
        spacing={1}
      >
        <Box
          sx={{
            width: '100%',
            height: '100%',
            maxWidth: '2560px !important',
            flexGrow: 1,
            position: 'relative',
          }}
        >
          <ErrorBoundary
            fallback={({ resetError }) => (
              <ErrorMessage resetError={resetError} />
            )}
          >
            {children}
          </ErrorBoundary>
        </Box>
      </Stack>

      <PosaleFooter
        footerLeftContent={footerLeftContent}
        footerRightContent={footerRightContent}
      />
    </>
  );
}
